import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconModule } from '@rd/shared-legacy/components/icon/icon.module';
import { OpenInNewTabModule } from '@rd/shared-legacy/directives/open-in-new-tab/open-in-new-tab.module';
import { BnzLinkComponent } from './link.component';

@NgModule({
  declarations: [BnzLinkComponent],
  imports: [CommonModule, IconModule, RouterModule, OpenInNewTabModule],
  exports: [BnzLinkComponent],
})
export class BnzLinkModule {}
